import React, { FC, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { startSetProtoType } from '../../../actions/protoTypeAction';
import { getPrototype } from '../../../selectors/protoTypeSelector';
import { baseUrl } from '../../../utils/constants';
import "../prototypeComponent.scss";

export interface PrototypeCardComponentProps {
    key: string;
    prototype: any;
}


const PrototypeCardComponent: FC<PrototypeCardComponentProps> = ({ key, prototype }) => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [pathId, setPathId] = useState("");
    const prototypeState = useSelector(getPrototype);
    const setPrototype = () => {
        dispatch(startSetProtoType(prototype));
    };

    return (
        <>
            <Modal
                size="lg"
                isOpen={show}
                show={show}
                onHide={() => {
                    setShow(false);
                }}
            >
                <Modal.Header className="theam-btn" closeButton>
                    <Modal.Title>Prototype Link</Modal.Title>
                </Modal.Header>
                <Modal.Body className="theam-btn">
                    <p>Path to Prototype</p>
                    <div className="input-group">
                        <a className="form-control"
                            rel="noopener , noreferrer"
                            href={`http://${baseUrl}preview/prototype-render/${pathId}`}
                            target="_blank"
                        >{`${baseUrl}preview/prototype-render/${pathId}`}</a>
                        <div className="input-group-append">
                            <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={() => {
                                    navigator.clipboard.writeText(
                                        `${baseUrl}preview/prototype-render/${pathId}`
                                    );
                                    toast.success("Copied to clipboard", {
                                        position: "top-right",
                                        autoClose: 2 * 1000,
                                    });
                                }}
                            >
                                <i className="fa fa-copy" aria-hidden="true" />
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <div key={key} className="form-item mr-0" onClick={() => { setPrototype() }}>
                <div
                    className={`row pr-0 form-name theam-font ${prototypeState.id === prototype.id
                        ? "form-active"
                        : ""
                        }`}
                >
                    <span className="col-9 pl-4 align-left">{prototype.name}</span>
                    
                    <span className="col-3 align-left pl-0">
                    <button
                    className="form-remove theam-dark-btn btn-dark"
                    onClick={(e) => {
                        e.stopPropagation();
                        setPathId(prototype.id);
                        setShow(true);
                    }}
                >
                    <i className="fa fa-eye" aria-hidden="true"></i>
                </button>
                    </span>
                </div>

            </div>
        </>
    )
}

export default PrototypeCardComponent
